import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { withGlobalData } from 'app/utils/withGlobalData';
import { findTranslate } from 'app/utils/translate';
import Detail from 'app/components/blogs/Detail';
import { updateAppName } from 'app/utils/string';
import * as blogApi from 'app/requests/blogs';

const redirectToNews = {
  redirect: {
    destination: '/news',
    permanent: false,
  },
};

export default function BlogDetail({ blog }) {
  return (
    <Detail blog={blog} typePage="blog" />
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const [blog, translations] = await Promise.all([
      blogApi.getBySlug(query.slug, locale),
      serverSideTranslations(locale, ['common']),
    ]);

    if (!blog) return redirectToNews;

    const getField = (key: string) => findTranslate(blog.translates, key, locale);

    return {
      props: {
        ...translations,
        blog: {
          ...blog,
          description: updateAppName(getField('description')),
          keywords: getField('keywords'),
          content: getField('content'),
          title: getField('title'),
          translates: [], // clear raw translates
        },
      },
    };
  } catch (error) {
    console.error('Error in getServerSideProps:', error);
    return redirectToNews;
  }
});
